export const DEPARTMENTS_URL = 'categories/root';
export const CATEGORY_BY_ID_URL = 'categories';
export const HOVER = 'j/hoverpanel';

/* This would be changed once the proper endpoint is provided */
/* Below constant would completely be changed once the proper end point is provided */
export const VISUAL_NAVIGATION_URL =
    'https://dt-test3.jcpenney.com/expcom-api/j/departments?dpAkamaiOverride=1';

// The is based on API https://wiki.jcpenney.com/display/DIGPLAT/Browse+API.
// It will be updated after we get formal department VisualNav API
export const VISUAL_NAVIGATION_HOME_URL = 'j/departments';

export const VISUAL_NAVIGATION_DEPT_URL = 'j/departments';

export const VISUAL_NAVIGATION_DEPT_OP_URL = 'j/department';

export const VISUAL_NAVIGATION_DEPT_OP = 'op=visnavzone';

export const VISUAL_LEFT_NAVIGATION_URL = 'j/x2LeftNavigation/';

export const L2_CAT = '/content-aggregator/globalnav/L2';
export const PRV_L2_CAT = '/prvcontent-aggregator/globalnav/L2';

export const FOOTER_CAT = '/content-aggregator/shared-components/zones/SiteWideFooter';
export const PRV_FOOTER_CAT = '/prvcontent-aggregator/shared-components/zones/SiteWideFooter';

/**
 * gallery page api changes start from here
 */
export const GALLERY_ZONE_URL = 'j/contentZone';
export const GALLERY_ZONE_INFO_URL = 'search-classifier/getsalezone';
/**
 * gallery page api changes end here
 */
export const SKU_URL = 'skus/?ids=';

/**
 * Compare Page API Details here
 */

export const COMPARE_PAGE_URL = 'product-compare';

export const JETLORE_URL = 'https://api.jetlore.com/products/products_by_filter.json';

/**
 * Compare Page API Details end here
 */

// cretio page url
export const CRITEO_URL = 'www.hlserve.com/delivery/v2/api/page';

export default {
    DEPARTMENTS_URL,
    CATEGORY_BY_ID_URL,
    VISUAL_NAVIGATION_URL,
    VISUAL_NAVIGATION_HOME_URL,
    VISUAL_NAVIGATION_DEPT_URL,
    VISUAL_NAVIGATION_DEPT_OP_URL,
    VISUAL_NAVIGATION_DEPT_OP,
    VISUAL_LEFT_NAVIGATION_URL,
    GALLERY_ZONE_URL,
    GALLERY_ZONE_INFO_URL,
    HOVER,
    SKU_URL,
    COMPARE_PAGE_URL,
    JETLORE_URL,
    CRITEO_URL,
    L2_CAT,
    PRV_L2_CAT,
};
